import OAuthState from '../types/oauth';

export default function oauth(state = {}, action): OAuthState {
  return state;
}
